import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';
import { Videos } from '../types/help-videos';

export const fetch = (config: ApiConfig) => (): Promise<Videos[]> =>
  fetchWrapper<Videos[]>(
    'https://opensheet.elk.sh/1JgNg86XXp1SfP0GZ4QeekYJ2aBVvohVlkMjNaOJ24L8/videos',
    {
      method: 'GET',
    },
    config
  );
